import { useCallback } from "react";

import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import type { HotelSettingsHotelInfoI18nFormModel } from "../../../../model/type";

type Props = {
	viewModel: HotelSettingsHotelInfoI18nFormModel["ViewModel"];
	onUpdate: () => Promise<void>;
};

export const useHotelSettingsHotelInfoDefault = ({ viewModel, onUpdate: _onUpdate }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const isDirty = viewModel.isDirty;
	const isValid = isDirty && !viewModel.hasError;

	const onUpdate = useCallback(async () => {
		showLoadingScreenCallback();

		await _onUpdate().finally(hideLoadingScreenCallback);
	}, [_onUpdate, hideLoadingScreenCallback, showLoadingScreenCallback]);

	return {
		isDirty,
		isValid,
		onUpdate,
	};
};
